export function homePage() {
  return `
    <div class="hero-container" style="text-align: center; padding: 50px;">
      <h1>Welcome to the AI Website Builder</h1>
      <p>Build, buy, and sell stunning templates instantly.</p>
      <a href="#marketplace"><button style="margin: 10px;">Browse Marketplace</button></a>
      <a href="#login"><button style="margin: 10px;">Login / Register</button></a>
    </div>
  `;
}